import React from 'react';
import ReactDOMServer from 'react-dom/server';
import PropTypes from 'prop-types';

import googleMapsLoader from 'js/google-maps-loader';

import MapPopup from './map-popup';
import Store from 'components/find-store/store';

class StoreMap extends React.Component {
  static propTypes = {
    googleMapsAPIKey: PropTypes.string,
    mapMarker: PropTypes.string,
    stores: PropTypes.arrayOf(PropTypes.exact(Store.propTypes))
  };

  // NOTE: All props are provided by FindStorePage
  static propTypesMeta = 'exclude';

  state = {};

  google = null;
  map = null;

  getBounds = stores => {
    const google = this.google;
    const bounds = new google.maps.LatLngBounds();

    //loop through all markers and create bounds
    if (stores && stores.length) {
      stores.forEach(store => {
        bounds.extend(new google.maps.LatLng(store.lat, store.lng));
      });
    }

    return bounds;
  };

  fitMapToStores = stores => {
    const bounds = this.getBounds(stores);
    // only 1 marker?
    if (stores.length === 1) {
      this.map.setCenter(bounds.getCenter());
      this.map.setZoom(16);
    } else {
      // fit to bounds
      this.map.fitBounds(bounds);
    }
  };

  componentDidMount() {
    googleMapsLoader(this.props.googleMapsAPIKey).then(google => {
      this.google = google;
      this.map = new google.maps.Map(this.wrapper);

      this.fitMapToStores(this.props.stores);

      const popupsAndMarkers = this.props.stores.map(store => {
        return {
          popup: new google.maps.InfoWindow({
            content: ReactDOMServer.renderToString(<MapPopup {...store} />)
          }),
          marker: new google.maps.Marker({
            position: { lat: store.lat, lng: store.lng },
            icon: this.props.mapMarker,
            title: store.name,
            map: this.map
          })
        };
      });

      popupsAndMarkers.forEach(({ popup, marker }) => {
        marker.addListener('click', () => {
          popupsAndMarkers.forEach(({ popup }) => popup.close());
          popup.open(this.map, marker);
        });
      });
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.stores !== this.props.stores) {
      this.fitMapToStores(this.props.stores);
    }
  }

  render() {
    return <div className="store-map" ref={div => (this.wrapper = div)} />;
  }
}

export default StoreMap;
